export const API_VERSION_HEADER = 'X-API-VERSION';

export const API_VERSION_STRICT_BENEFICIARY = '2';

export const API_VERSION_MOVEMENTS = '2';
